import React, { Component } from 'react'
import PageNo from "../common/PageNo";
const userSession = localStorage.getItem("userSession");
const data = userSession ? JSON.parse(userSession) : {};
export default class CartecFooter extends Component {
  render() {
    return (
      <>
        <div className="container p-0 bottom-footer-pdf">
          <div className="row p-0">
            <div className="col-lg-1 col-md-12 col-sm-12 p-0">
              <p style={{background:"#D81808",}}></p>
              <p style={{background:"#000000",}}></p>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 p-0 call-info">
              <div className="row p-0">
                <div className="col-4">
                  <img style={{ width: 50, height: 50 }} src={require("../../assets/img/brand/phone.png")} alt="Phone Icon" />
                </div>
                <div className="col-8 p-0">
                  <h1>+056 464 00 50</h1>
                  <h1>+058 710 31 61</h1>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 p-0 call-info">
              <div className="row p-0">
                <div className="col-4">
                  <img style={{ width: 50, height: 50 }} src={require("../../assets/img/brand/web.png")} alt="Phone Icon" />
                </div>
                <div className="col-8 p-0">
                  <h1>www.cartec.ch</h1>
                  <h1>info@cartec.ch</h1>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 p-0 call-info address-info">
              <div className="row p-0">
                <div className="col-3">
                  <img src={require("../../assets/img/brand/location.png")} style={{ width: 50, height: 50 }} alt="Phone Icon" />
                </div>
                <div className="col-9 p-0">
                  <h1>CARTEC Carrosserie-Technik AG</h1>
                  <h1>Hiibelacherstrasse 16 5242 Lupfig</h1>
                </div>
              </div>
            </div>
            <div className="col-lg-1 col-md-12 col-sm-12 p-0 footer-color">
                <p style={{background:"#D81808",}}></p>
                <p style={{background:"#000000",}}></p>
            </div>
          </div>
          <div className="row copyright-footer">
            <div className="col-sm-12">
              <PageNo carNo={data.regNo} current="1" total="2" />
            </div>
          </div>
        </div>
      </>
    )
  }
}
